import React from 'react';
import { connect } from 'react-redux';

import { hideMessage } from './messageDucks';

class Message extends React.Component {
  static timeout = null;

  componentDidMount() {
    /*
     * Inits if required a timeout to hide the message.
     * This is required because the componentWillReceiveProps
     * function is not called during mounting.
     */
    const { message: { duration, hidden } } = this.props;
    if (!hidden && Message.timeout === null) {
      this.createHideTimeout(duration);
    }
  }

  componentWillReceiveProps(newProps) {
    const {
      message: {
        hidden,
        text,
      },
    } = this.props;
    const {
      message: {
        hidden: newHidden,
        text: newText,
        duration,
      },
    } = newProps;

    /*
     * Launching a timeout if either :
     *  - A message must be displayed and no message was displayed,
     *  - A message must be displayed and a previous message was displayed.
     *
     * If there was already a timeout. This one is cancelled.
     */
    if (!newHidden && (hidden || text !== newText)) {
      if (Message.timeout) {
        window.clearTimeout(Message.timeout);
      }
      this.createHideTimeout(duration);
    }
  }

  onHideClick = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch(hideMessage());
    if (Message.timeout !== null) {
      window.clearTimeout(Message.timeout);
      Message.timeout = null;
    }
  };

  createHideTimeout = (duration) => {
    const { dispatch } = this.props;

    if (duration) {
      Message.timeout = window.setTimeout(() => {
        Message.timeout = null;
        dispatch(hideMessage());
      }, duration);
    }
  };

  render() {
    const {
      message: {
        icon,
        hidden,
        text,
        type,
      },
    } = this.props;

    return (
      <div
        className={`alert global-message message-${type.toLowerCase()} `
        + (hidden ? 'message-hidden' : 'message-displayed')}
      >
        <div className="alert-msg" id="alert">
          <div className="close-msg" onClick={this.onHideClick}>
            <span><i className="ic ic-close"/></span>
          </div>
          <div className="alert-msg-content">
            <span><i className={'ic ' + (icon || '')}/></span>
            <span>{text}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  message: state.message,
}))(Message);



// WEBPACK FOOTER //
// ./book/src/commons/components/message/Message.jsx